// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled from 'styled-components';
var PlayroomBadgeCardCompletedStyled = /*#__PURE__*/styled.article.withConfig({
  componentId: "sc-12npq59-0"
})(["\n  @keyframes gradient {\n    0% {\n      background-position: 0 100%;\n    }\n    100% {\n      background-position: 0 0;\n    }\n  }\n\n  background-image: linear-gradient(\n    to top,\n    transparent,\n    transparent 50%,\n    ", " 50%,\n    ", "\n  );\n  background-position: 0 100%;\n  background-size: 100% 200%;\n  animation: gradient 250ms ease-in 620ms forwards;\n"], function (_ref) {
  var hexadecimalColor = _ref.hexadecimalColor;
  return hexadecimalColor;
}, function (_ref2) {
  var hexadecimalColor = _ref2.hexadecimalColor;
  return hexadecimalColor;
});
export default PlayroomBadgeCardCompletedStyled;